import { Alert, Button } from "@mui/material";
import React, { useState } from "react";
import { connect } from "react-redux";
import BlindIcon from "@mui/icons-material/Blind";
const VisualImpairmentNote = (props) => {
  const { loading, userProfileStatus } = props;

  return (
    <>
      {!!userProfileStatus?.hasVisualImpairment && (
        <Alert
          role="alert"
          severity="info"
          icon={false}
          className="d-flex py-0 mb-n3 justify-content-center align-items-center text-uppercase"
        >
          We acknowledge that you have a visual impairment.
        </Alert>
      )}
    </>
  );
};

const mapStateToProps = ({ loading, userProfileStatus }) => ({
  loading,
  userProfileStatus,
});

export default connect(mapStateToProps, {})(VisualImpairmentNote);
